import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useFacility } from '../context/FacilityContext';

const ImpersonationBanner = () => {
  const navigate = useNavigate();
  const { impersonation, exitImpersonation } = useAuth();
  const facility = useFacility();
  const [exiting, setExiting] = useState(false);

  if (!impersonation) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await exitImpersonation();
      if (facility && typeof facility.refreshFacilities === 'function') {
        await facility.refreshFacilities();
      }
      navigate('/platform-admin');
    } finally {
      setExiting(false);
    }
  };

  return (
    <div className="bg-amber-500 text-white">
      <div className="px-4 md:px-6 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <Eye className="h-4 w-4 flex-shrink-0" />
          <p className="text-[13px] font-medium truncate">
            Support session active — viewing <span className="font-semibold">{impersonation.organization_name}</span>. Every action is audit-logged.
          </p>
        </div>
        <button
          onClick={handleExit}
          disabled={exiting}
          className="flex items-center gap-1.5 px-2.5 py-1 text-[12px] font-semibold bg-white/15 hover:bg-white/25 rounded-md transition-colors disabled:opacity-50 flex-shrink-0"
        >
          <LogOut className="h-3 w-3" />
          {exiting ? 'Exiting…' : 'Exit session'}
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
